'use client';

import { c as _c } from "react/compiler-runtime";
import { FormControl, FormLabel, TextField } from '@mui/material';
import { InputErrorIcon } from '@/components/form/validation/inputErrorIcon';
import { inputSx } from './fieldStyles';
export const InlineErrorField = t0 => {
  const $ = _c(28);
  const {
    id,
    label,
    value,
    onChange,
    errorMessage,
    type: t1,
    autoFocus: t2
  } = t0;
  const type = t1 === undefined ? "text" : t1;
  const autoFocus = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== id || $[1] !== label) {
    t3 = <FormLabel htmlFor={id}>{label}</FormLabel>;
    $[0] = id;
    $[1] = label;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = type === "password" ? "new-password" : undefined;
  let t5;
  if ($[3] !== onChange) {
    t5 = e => onChange(e.target.value);
    $[3] = onChange;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const t6 = !!errorMessage;
  const t7 = errorMessage ? "4px" : undefined;
  let t8;
  if ($[5] !== t7) {
    t8 = {
      ...inputSx,
      "& .MuiInputBase-root": {
        paddingRight: t7
      }
    };
    $[5] = t7;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] !== id) {
    t9 = {
      id,
      "data-testid": id
    };
    $[7] = id;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] !== errorMessage) {
    t10 = errorMessage ? <InputErrorIcon errorMessage={errorMessage} /> : undefined;
    $[9] = errorMessage;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== t10) {
    t11 = {
      endAdornment: t10
    };
    $[11] = t10;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== t11 || $[14] !== t9) {
    t12 = {
      htmlInput: t9,
      input: t11
    };
    $[13] = t11;
    $[14] = t9;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== autoFocus || $[17] !== t12 || $[18] !== t4 || $[19] !== t5 || $[20] !== t6 || $[21] !== t8 || $[22] !== type || $[23] !== value) {
    t13 = <TextField type={type} autoFocus={autoFocus} autoComplete={t4} value={value} onChange={t5} error={t6} sx={t8} slotProps={t12} />;
    $[16] = autoFocus;
    $[17] = t12;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
    $[21] = t8;
    $[22] = type;
    $[23] = value;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t13 || $[26] !== t3) {
    t14 = <FormControl size="small" className="w-full">{t3}{t13}</FormControl>;
    $[25] = t13;
    $[26] = t3;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  return t14;
};